import React from 'react';

export const RotateCwIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} {...props}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 3l3 3m0 0l-3 3m3-3H7a4 4 0 00-4 4v2" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 21l-3-3m0 0l3-3m-3 3h11a4 4 0 004-4v-2" />
  </svg>
);